import React, { useState, useEffect } from 'react';
import { buscarRelatorios } from '../services/api';
import { CAMPANHAS } from '../services/utils';

export default function Relatorios() {
  const [dados,     setDados]     = useState(null);
  const [carregando,setCarregando]= useState(true);

  useEffect(() => {
    buscarRelatorios()
      .then(({ data }) => setDados(data))
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, []);

  if (carregando) return <div style={styles.loading}><i className="ti ti-loader-2" style={{ fontSize: 28, animation: 'spin 1s linear infinite' }} /></div>;
  if (!dados)     return null;

  const { totais, por_campanha } = dados;
  const cards = [
    { label: 'Total',           val: totais.total,          bg: '#f0f2f5', color: '#1a1f2e', icon: 'ti-messages' },
    { label: 'Aguardando',      val: totais.aguardando,     bg: '#fff8e6', color: '#92540a', icon: 'ti-clock' },
    { label: 'Em atendimento',  val: totais.em_atendimento, bg: '#dcfce7', color: '#14532d', icon: 'ti-headset' },
    { label: 'Resolvidas',      val: totais.resolvida,      bg: '#ede9fe', color: '#5b21b6', icon: 'ti-check' },
  ];

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h2 style={styles.title}>Relatórios</h2>
        <p style={styles.sub}>Visão geral dos atendimentos</p>
      </div>

      {/* Cards */}
      <div style={styles.cards}>
        {cards.map(c => (
          <div key={c.label} style={{ ...styles.card, background: c.bg }} className="animate-fade">
            <i className={`ti ${c.icon}`} style={{ fontSize: 22, color: c.color, marginBottom: 8 }} />
            <div style={{ fontSize: 28, fontWeight: 700, color: c.color }}>{c.val || 0}</div>
            <div style={{ fontSize: 12, color: c.color, opacity: 0.7, marginTop: 2 }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Por campanha */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>Conversas por campanha</h3>
        <div style={styles.campList}>
          {por_campanha.map(c => {
            const info = CAMPANHAS[c.campanha] || {};
            const pct  = totais.total ? Math.round(c.total / totais.total * 100) : 0;
            return (
              <div key={c.campanha} style={styles.campRow}>
                <span className="pill" style={{ background: info.bg, color: info.text, minWidth: 130 }}>
                  {info.label || c.campanha}
                </span>
                <div style={styles.barWrap}>
                  <div style={{ ...styles.bar, width: `${pct}%`, background: info.text || '#25D366' }} />
                </div>
                <span style={styles.campVal}>{c.total}</span>
                <span style={styles.campRes}>{c.resolvidas} resolvidas</span>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

const styles = {
  page:    { flex: 1, overflowY: 'auto', padding: 24, background: 'var(--bg-app)' },
  loading: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)' },
  header:  { marginBottom: 20 },
  title:   { fontSize: 18, fontWeight: 700, color: 'var(--text-primary)' },
  sub:     { fontSize: 12, color: 'var(--text-muted)', marginTop: 2 },
  cards:   { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 24 },
  card:    { borderRadius: 14, padding: '18px 16px', border: '1px solid var(--border)', display: 'flex', flexDirection: 'column' },
  section: { background: '#fff', borderRadius: 14, padding: 20, border: '1px solid var(--border)' },
  sectionTitle: { fontSize: 14, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 16 },
  campList: { display: 'flex', flexDirection: 'column', gap: 12 },
  campRow: { display: 'flex', alignItems: 'center', gap: 12 },
  barWrap: { flex: 1, background: '#f0f2f5', borderRadius: 99, height: 8, overflow: 'hidden' },
  bar:     { height: '100%', borderRadius: 99, transition: 'width 0.6s ease' },
  campVal: { fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', minWidth: 24, textAlign: 'right' },
  campRes: { fontSize: 11, color: 'var(--text-muted)', minWidth: 90 },
};
